module.exports = __webpack_public_path__ + "static/media/price.d3366f6e.png";